import { useEffect } from "react";
import { LoaderSpinner } from "../../components/LoaderSpinner";
import axios from "axios";

const DisconnectQB = () => {
    let counter = 1;
    const disconnectFromQB = async () => {
        try {
            const { data } = await axios.post('api/v1/disconnect-quickbooks');
            window.location.href = data.url;
        } catch (error) { 
            console.error(error) 
        }
    }  
    
    useEffect(() => {
        if (counter === 1) {
            counter += 1;
            setTimeout(async () => {
                await disconnectFromQB();
            }, 2000)
        }
        // eslint-disable-next-line
    }, [counter]);

    return (
        <div className="h-5/6 w-full absolute">
            <LoaderSpinner colorSpinner="black" width="70" height="70" border="5" />
        </div>
    )
}

export default DisconnectQB;